import React, { Component } from "react";
import { MessageSourceProps, withMessages } from 'react-message-source';
import { Button, Grid, Modal } from 'semantic-ui-react';
import FormModalContentContainer from 'components/layout/FormModalContentContainer';
import PraxFormGrid from 'components/layout/PraxFormGrid';


interface Props extends MessageSourceProps {
  messageHeader: string,
  message: string,
  onConfirmAction: () => void,
  onCancelAction: () => void,
  modalOpen: boolean
}

class ConfirmActionModal extends Component<Props> {

  render(): React.ReactNode {

    const {messageHeader, onCancelAction, modalOpen, getMessage, onConfirmAction} = this.props;

    return (
        <Modal
            open={modalOpen}
            onClose={onCancelAction}
            closeOnDimmerClick={false}
        >
          <Modal.Header>
            {messageHeader}
          </Modal.Header>
          <FormModalContentContainer>
            {this.renderModalContent()}
          </FormModalContentContainer>
          <Modal.Actions>
            <Button compact primary type="button" onClick={onConfirmAction}>{getMessage("button.yes")}</Button>
            <Button compact type="button"
                    onClick={onCancelAction}>{getMessage("button.no")}</Button>
          </Modal.Actions>
        </Modal>
    );
  }

  renderModalContent = (): React.ReactNode => {

    const {message} = this.props;

    return (
        <PraxFormGrid>
          <Grid.Row>
            <Grid.Column>
              {message}
            </Grid.Column>
          </Grid.Row>
        </PraxFormGrid>
    )
  }
}

export default withMessages(ConfirmActionModal);
